import React, { useState, useRef, useEffect } from 'react';

const BG       = '#07001a';
const CARD     = 'rgba(255,255,255,0.03)';
const BORDER   = 'rgba(123,110,246,0.14)';
const ACCENT   = '#7B6EF6';
const ACCENT_D = 'rgba(123,110,246,0.15)';
const TEXT     = '#E8E3F8';
const MUTED    = '#4D4669';
const GREEN    = '#3ECF7A';

const CONVERSATIONS = [
  { id: 1, initials: 'LS', name: 'Lamia Sayed',   role: 'Senior Frontend Dev', preview: 'Hi! I just completed the Senior...', time: '2m',  unread: 3, color: '#6c63ff' },
  { id: 2, initials: 'AJ', name: 'Ahmed Jawad',   role: 'Full Stack Developer',  preview: 'Looking forward to the next step...', time: '14m', unread: 0, color: '#4f9eff' },
  { id: 3, initials: 'SK', name: 'Sara Kadri',    role: 'UI/UX Designer',        preview: 'Thanks for reaching out...',         time: '1h',  unread: 0, color: '#22c55e' },
  { id: 4, initials: 'KM', name: 'Kofi Mensah',   role: 'Backend Engineer',      preview: 'Quick question about the role...',   time: '2h',  unread: 3, color: '#a855f7' },
  { id: 5, initials: 'FO', name: 'Fairouz Oweza', role: 'DevOps Engineer',       preview: 'Accepted the interview invite!',     time: '3h',  unread: 0, color: '#f59e0b' },
  { id: 6, initials: 'SA', name: 'Sofia Amrawi',  role: 'Data Scientist',        preview: 'Looking forward to it!',             time: '5h',  unread: 0, color: '#06b6d4' },
  { id: 7, initials: 'CV', name: 'Celia Vaya',    role: 'Mobile Developer',      preview: 'Is the position still open?',        time: '1d',  unread: 0, color: '#ef4444' },
  { id: 8, initials: 'LF', name: 'Luca Ferrakh',  role: 'Cloud Architect',       preview: 'Sounds good! Thanks!',               time: '2d',  unread: 0, color: '#84cc16' },
];

const INITIAL_MESSAGES = {
  2: [
    { id: 1, from: 'candidate', text: "Hi! I just completed the Senior Frontend Developer test. Looking forward to hearing back.", time: '10:32 AM' },
    { id: 2, from: 'company',   text: "Hi Ahmed — your score of 96.2 was exceptional, one of the best we've seen this quarter.", time: '10:45 AM' },
    { id: 3, from: 'candidate', text: "That's great to hear! What are the next steps?", time: '10:46 AM' },
    { id: 4, from: 'company',   text: "We'd love to schedule a technical interview. Are you available next week? Particularly impressed by your system design work.", time: '10:48 AM' },
    { id: 5, from: 'candidate', text: "Absolutely — Monday through Thursday after 10 AM works well for me.", time: '10:52 AM' },
  ],
};

export default function Messages() {
  const [activeId, setActiveId]     = useState(2);
  const [input, setInput]           = useState('');
  const [threads, setThreads]       = useState(INITIAL_MESSAGES);
  const [search, setSearch]         = useState('');
  const [convs, setConvs]           = useState(CONVERSATIONS);
  const messagesEndRef               = useRef(null);

  const activeCon  = convs.find(c => c.id === activeId);
  const activeThread = threads[activeId] || [];

  const filtered = convs.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase()) ||
    c.preview.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [activeThread.length]);

  const sendMessage = () => {
    const trimmed = input.trim();
    if (!trimmed) return;
    const now = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const newMsg = { id: Date.now(), from: 'company', text: trimmed, time: now };
    setThreads(prev => ({ ...prev, [activeId]: [...(prev[activeId] || []), newMsg] }));
    setConvs(prev => prev.map(c => c.id === activeId ? { ...c, preview: trimmed, time: 'Now' } : c));
    setInput('');
  };

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', height: '100vh',
      background: BG, fontFamily: "'Inter', sans-serif", color: TEXT, overflow: 'hidden'
    }}>
      {/* ── TOP BAR ─────────────────────────────────────────── */}
      <div style={{
        padding: '28px 32px 20px',
        borderBottom: `1px solid ${BORDER}`,
        flexShrink: 0,
        background: 'rgba(7,0,26,0.95)',
        backdropFilter: 'blur(12px)'
      }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: TEXT, letterSpacing: '-0.4px' }}>
          Messages
        </h1>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: MUTED }}>
          Direct communication with candidates and your team
        </p>
      </div>

      {/* ── MAIN LAYOUT ─────────────────────────────────────── */}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>

        {/* ── LEFT: CONVERSATION LIST ──────────────────────── */}
        <div style={{
          width: 300, flexShrink: 0,
          display: 'flex', flexDirection: 'column',
          borderRight: `1px solid ${BORDER}`,
          background: 'rgba(255,255,255,0.015)'
        }}>
          {/* Search */}
          <div style={{ padding: '14px 16px', borderBottom: `1px solid ${BORDER}` }}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: 8,
              background: 'rgba(255,255,255,0.04)',
              border: `1px solid ${BORDER}`,
              borderRadius: 10, padding: '8px 12px'
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={MUTED} strokeWidth="2.5" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
              <input
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search messages..."
                style={{
                  background: 'none', border: 'none', outline: 'none',
                  color: TEXT, fontSize: 12, flex: 1,
                }}
              />
            </div>
          </div>

          {/* List */}
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {filtered.map(c => {
              const isActive = c.id === activeId;
              return (
                <div
                  key={c.id}
                  onClick={() => setActiveId(c.id)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 12,
                    padding: '12px 16px', cursor: 'pointer',
                    background: isActive ? ACCENT_D : 'transparent',
                    borderLeft: isActive ? `3px solid ${ACCENT}` : '3px solid transparent',
                    transition: 'all 0.15s',
                    borderBottom: `1px solid rgba(255,255,255,0.03)`
                  }}
                  onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}
                  onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
                >
                  {/* Avatar */}
                  <div style={{
                    width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
                    background: c.color,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 13, fontWeight: 700, color: '#fff',
                    boxShadow: `0 0 0 2px ${isActive ? ACCENT : 'transparent'}`
                  }}>
                    {c.initials}
                  </div>

                  {/* Content */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: TEXT, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.name}</span>
                      <span style={{ fontSize: 10, color: MUTED, flexShrink: 0, marginLeft: 8 }}>{c.time}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: 11, color: MUTED, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 160 }}>
                        {c.preview}
                      </span>
                      {c.unread > 0 && (
                        <span style={{
                          background: ACCENT, color: '#fff',
                          fontSize: 10, fontWeight: 700,
                          width: 18, height: 18, borderRadius: '50%',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          flexShrink: 0, marginLeft: 6
                        }}>
                          {c.unread}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* ── RIGHT: CHAT WINDOW ───────────────────────────── */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

          {/* Chat Header */}
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '14px 24px', borderBottom: `1px solid ${BORDER}`,
            background: 'rgba(255,255,255,0.015)', flexShrink: 0
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{
                width: 42, height: 42, borderRadius: '50%',
                background: activeCon?.color,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 14, fontWeight: 700, color: '#fff',
                boxShadow: `0 0 0 3px rgba(123,110,246,0.25)`
              }}>
                {activeCon?.initials}
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: TEXT }}>{activeCon?.name}</div>
                <div style={{ fontSize: 11, color: MUTED }}>{activeCon?.role}</div>
              </div>
              <div style={{
                display: 'flex', alignItems: 'center', gap: 5,
                marginLeft: 8, padding: '3px 10px', borderRadius: 20,
                background: 'rgba(62,207,122,0.1)', border: '1px solid rgba(62,207,122,0.2)'
              }}>
                <span style={{ width: 6, height: 6, borderRadius: '50%', background: GREEN, display: 'inline-block' }}></span>
                <span style={{ fontSize: 10, color: GREEN, fontWeight: 600 }}>Online</span>
              </div>
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              <button style={{
                background: 'rgba(255,255,255,0.04)', border: `1px solid ${BORDER}`,
                color: MUTED, padding: '7px 14px', borderRadius: 8,
                fontSize: 11, fontWeight: 600, cursor: 'pointer'
              }}>
                View Profile
              </button>
              <button style={{
                background: ACCENT_D, border: `1px solid rgba(123,110,246,0.35)`,
                color: '#B8B0F8', padding: '7px 14px', borderRadius: 8,
                fontSize: 11, fontWeight: 600, cursor: 'pointer'
              }}>
                📅 Schedule Interview
              </button>
            </div>
          </div>

          {/* Messages Area */}
          <div style={{
            flex: 1, overflowY: 'auto', padding: '24px',
            display: 'flex', flexDirection: 'column', gap: 16
          }}>
            {/* Date divider */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ flex: 1, height: 1, background: BORDER }} />
              <span style={{ fontSize: 11, color: MUTED, whiteSpace: 'nowrap' }}>Today</span>
              <div style={{ flex: 1, height: 1, background: BORDER }} />
            </div>

            {activeThread.map(m => {
              const isCompany = m.from === 'company';
              return (
                <div key={m.id} style={{
                  display: 'flex', flexDirection: isCompany ? 'row-reverse' : 'row',
                  alignItems: 'flex-end', gap: 10
                }}>
                  {/* Avatar */}
                  {!isCompany && (
                    <div style={{
                      width: 32, height: 32, borderRadius: '50%', flexShrink: 0,
                      background: activeCon?.color,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 11, fontWeight: 700, color: '#fff'
                    }}>
                      {activeCon?.initials}
                    </div>
                  )}

                  <div style={{ maxWidth: '62%', display: 'flex', flexDirection: 'column', gap: 4, alignItems: isCompany ? 'flex-end' : 'flex-start' }}>
                    {/* Bubble */}
                    <div style={{
                      padding: '11px 15px',
                      borderRadius: isCompany ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                      fontSize: 13,
                      lineHeight: 1.55,
                      background: isCompany
                        ? 'linear-gradient(135deg, rgba(123,110,246,0.25) 0%, rgba(123,110,246,0.15) 100%)'
                        : 'rgba(255,255,255,0.05)',
                      border: `1px solid ${isCompany ? 'rgba(123,110,246,0.3)' : BORDER}`,
                      color: TEXT,
                      boxShadow: isCompany ? '0 4px 12px rgba(123,110,246,0.15)' : 'none'
                    }}>
                      {m.text}
                    </div>
                    {/* Time */}
                    <span style={{ fontSize: 10, color: MUTED, paddingLeft: isCompany ? 0 : 4, paddingRight: isCompany ? 4 : 0 }}>{m.time}</span>
                  </div>
                </div>
              );
            })}

            {activeThread.length === 0 && (
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, paddingTop: 60 }}>
                <div style={{ fontSize: 48 }}>💬</div>
                <p style={{ color: MUTED, fontSize: 14, margin: 0 }}>No messages yet. Start the conversation!</p>
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          {/* Compose Bar */}
          <div style={{
            padding: '14px 24px', borderTop: `1px solid ${BORDER}`,
            background: 'rgba(255,255,255,0.015)', flexShrink: 0
          }}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: 10,
              background: 'rgba(255,255,255,0.04)',
              border: `1px solid ${BORDER}`,
              borderRadius: 12, padding: '10px 14px'
            }}>
              {/* Attachment icon */}
              <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: MUTED, padding: 0, display: 'flex' }}
                title="Attach file">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
                </svg>
              </button>

              <input
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
                placeholder={`Message ${activeCon?.name?.split(' ')[0]}...`}
                style={{
                  flex: 1, background: 'none', border: 'none', outline: 'none',
                  color: TEXT, fontSize: 13,
                }}
              />

              {/* Emoji icon */}
              <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: MUTED, padding: 0, fontSize: 16 }} title="Emoji">
                😊
              </button>

              {/* Send */}
              <button
                onClick={sendMessage}
                style={{
                  background: input.trim() ? ACCENT : ACCENT_D,
                  border: 'none', borderRadius: 8,
                  width: 34, height: 34,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: input.trim() ? 'pointer' : 'default',
                  transition: 'all 0.2s',
                  flexShrink: 0
                }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={input.trim() ? '#fff' : MUTED} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/>
                </svg>
              </button>
            </div>
            <p style={{ fontSize: 10, color: MUTED, marginTop: 6, textAlign: 'right' }}>
              Press <kbd style={{ background: ACCENT_D, border: `1px solid ${BORDER}`, borderRadius: 3, padding: '1px 5px', color: '#B8B0F8', fontSize: 10 }}>Enter</kbd> to send
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}